export const RTW_SAME_DAY_MESSAGE =
  'A return-to-work was already submitted for this employee at [0] CST on [1]. Only one submission is permitted per calendar day. Another submission may be made beginning at 12:00 AM CST on [2].';

export function buildRtwSameDayMessage(
  template: string,
  submissionTime: string,
  submissionDate: string,
  nextEligibleDate: string
): string {
  return template
    .replace('[0]', submissionTime)
    .replace('[1]', submissionDate)
    .replace('[2]', nextEligibleDate);
}
